module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "side-bar"
  }, [_c('p', {
    staticClass: "appName"
  }, [_vm._v(_vm._s(_vm.appName))]), _vm._v(" "), _c('el-menu', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "router": "",
      "background-color": "#009E7D",
      "text-color": "#FFFFFF",
      "active-text-color": "#ffffff",
      "default-active": _vm.activeIndex
    }
  }, [(_vm.subMenuIndex && _vm.subMenuIndex[0]) ? _c('el-menu-item', {
    staticStyle: {
      "padding": "0 30px !important"
    },
    attrs: {
      "index": _vm.subMenuIndex[0].url
    }
  }, [(_vm.subMenuIndex[0].attrs && _vm.subMenuIndex[0].attrs.icon) ? _c('img', {
    attrs: {
      "src": _vm.getImgSrc(_vm.subMenuIndex[0].attrs.icon),
      "alt": "",
      "width": "20px",
      "height": "20px"
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "18px"
    },
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.subMenuIndex[0].title))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.subMenu), function(menu, index) {
    return [_c('el-submenu', {
      key: index,
      staticClass: "huaHover",
      attrs: {
        "index": ("" + index)
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "18px",
        "padding-left": "6px !important"
      },
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [(menu.attrs && menu.attrs.icon) ? _c('img', {
      attrs: {
        "src": _vm.getImgSrc(menu.attrs.icon),
        "alt": "",
        "width": "20px",
        "height": "20px"
      }
    }) : _vm._e(), _vm._v("\n          " + _vm._s(menu.title) + "\n        ")]), _vm._v(" "), (menu.children != '') ? _c('el-menu-item-group', _vm._l((menu.children), function(subitem, idx) {
      return _c('div', {
        key: idx
      }, [_c('el-menu-item', {
        key: subitem.url,
        staticStyle: {
          "padding-left": "0px !important"
        },
        attrs: {
          "index": subitem.url,
          "route": {
            name: subitem.url
          }
        }
      }, [_vm._v("\n              " + _vm._s(subitem.title) + "\n            ")])], 1)
    }), 0) : _vm._e()], 1)]
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45e7e6f8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Menu.vue
// module id = 685
// module chunks = 1